import stringifySelect from './stringifySelect';
import { projectStatuses } from '../constants';

export const roomsTitle = (values, translate, isfullTitle) => {
  if (!values || values[0] === 'all' || !values.length) {
    return isfullTitle ? `${translate('searchContainer', 'all_rooms')}` : `${translate('searchContainer', 'all')}`;
  }
  values.map(el => ((Number.isNaN(el)) ? el : +el));
  const rooms = stringifySelect(values.sort());

  if (isfullTitle) {
    if (+rooms === 1) {
      return translate('searchContainer', 'room');
    }
    return `${rooms} ${translate('searchContainer', 'rooms')}`;
  }
  return rooms + ((values.length > 1) ? ` ${translate('searchContainer', 'rooms')}` : '');
};

export const propertyTypesTitle = (values, translate, isfullTitle) => {
  if (values.length < 2) {
    return (values[0] && values[0] !== 'all')
      ? `${translate('propertyTypes', values[0])}`
      : `${translate('search_box', 'searchContainer', (isfullTitle) ? 'all_property_types' : 'all')}`;
  }
  return `${values.length} ${translate('search_box', 'searchContainer', 'property_type')}`;
};

export const agentsTitle = (values, options, translate) => {
  if (values.length < 2) {
    const [first] = values;
    const selectedOption = options.find((option) => option.value === first);
    return first && first !== 'all'
      ? selectedOption.label
      : `${translate('managePage', 'allAgents')}`;
  }
  return `${values.length} ${translate('managePage', 'agents')}`;
};

export const bathToiletsTitle = (values, translate) => {
  if (!values || values[0] === 'all' || !values.length) {
    return `${translate('search_box', 'searchContainer', 'all')}`;
  }
  values.map(el => ((Number.isNaN(el)) ? el : +el));
  const bathrooms = stringifySelect(values.sort());
  return bathrooms;
};

export const projectStatusesTitle = (values, locale, translate, isFullTitle) => {
  if (values.length < 2) {
    return (values[0] && values[0] !== 'all')
      ? projectStatuses.find(({ name }) => (values[0] === name)).localisation[locale]
      : `${translate('searchContainer', (isFullTitle) ? 'all_statuses' : 'all')}`;
  }
  return `${values.length} ${translate('searchContainer', 'status')}`;
};
